export default {
  getListStore: state => state.listStore
}
